import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { authService } from './services/authService';
import { ToastProvider } from './components/ui';

// Layout
import Layout from './components/common/Layout';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OperationalDashboard from './pages/OperationalDashboard';
import OperationalAnalytics from './pages/OperationalAnalytics';
import AdvancedAnalytics from './pages/AdvancedAnalytics';
import AndonBoard from './pages/AndonBoard';
import GateEntry from './pages/GateEntry';
import GateEntryList from './pages/GateEntryList';
import DockManagement from './pages/DockManagement';
import DockAnalytics from './pages/DockAnalytics';
import TruckQueue from './pages/TruckQueue';
import Unloading from './pages/Unloading';
import MaterialReceipt from './pages/MaterialReceipt';
import QCInspection from './pages/QCInspection';
import QCInspectionReview from './pages/QCInspectionReview';
import GRNCreation from './pages/GRNCreation';
import GRNManagement from './pages/GRNManagement';
import MB52StockOverview from './pages/MB52StockOverview';
import SAPIntegration from './pages/SAPIntegration';
import WorkflowEngine from './pages/WorkflowEngine';
import Management from './pages/Management';
import AccessControl from './pages/AccessControl';
import WorkflowConfiguration from './pages/WorkflowConfiguration';
import SystemSettings from './pages/SystemSettings';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="operational-dashboard" element={<OperationalDashboard />} />
            <Route path="operational-analytics" element={<OperationalAnalytics />} />
            <Route path="analytics-advanced" element={<AdvancedAnalytics />} />
            <Route path="andon-board" element={<AndonBoard />} />
            <Route path="workflow-engine" element={<WorkflowEngine />} />
            <Route path="gate-entry" element={<GateEntry />} />
            <Route path="gate-entry-list" element={<GateEntryList />} />
            <Route path="dock-management" element={<DockManagement />} />
            <Route path="dock-analytics" element={<DockAnalytics />} />
            <Route path="truck-queue" element={<TruckQueue />} />
            <Route path="unloading" element={<Unloading />} />
            <Route path="material-receipt/:operationId" element={<MaterialReceipt />} />
            <Route path="qc-inspection" element={<QCInspection />} />
            <Route path="qc-review" element={<QCInspectionReview />} />
            <Route path="grn-creation" element={<GRNCreation />} />
            <Route path="grn-management" element={<GRNManagement />} />
            <Route path="mb52-stock" element={<MB52StockOverview />} />
            <Route path="sap-integration" element={<SAPIntegration />} />
            <Route path="management" element={<Management />} />
            <Route path="access-control" element={<AccessControl />} />
            <Route path="workflow-config" element={<WorkflowConfiguration />} />
            <Route path="system-settings" element={<SystemSettings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
